exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-095fa0a4]{height:fit-content}", ""]);

// exports
